'use strict'

/* __________________________________________________________________________
|                               I M P O R T S                                |
|__________________________________________________________________________ */

import type { ProjectData } from '@js/types'
import { HomeScene } from '@js/lib/3d'
import { CURSOR, COMPONENTS, CONSTANTS } from '@js/global'
import { CSSManager, DataProcessor } from '@js/loaders'
import { 
  Notifbar, 
  Captcha, 
  Alertbox, 
  APropos, 
  Project, 
  ImgCursor, 
  // Radio, 
  // Chatbox, 
  Actu, 
  ThibTheCatElement 
} from '@js/components'

import CSS_RAW_VAR from '@css/sass/styles.module.scss'

/* __________________________________________________________________________
|                          A P P   M A N A G E R                             |
|__________________________________________________________________________ */

class AppManager {
  private cssManager: CSSManager
  private dataProcessor: DataProcessor

  constructor() {
    this.cssManager = new CSSManager(CSS_RAW_VAR)
    this.dataProcessor = new DataProcessor()
  }

  /**
   * Initialize the application
   */
  async initialize(): Promise<void> {
    // 1. Load CSS variables
    CONSTANTS.css = this.cssManager.loadVariables()
    
    // 2. Load all dependencies
    COMPONENTS.projects.data = await this.dataProcessor.loadProjectData()
    const chatbotData = this.dataProcessor.getChatbotData()
    console.log('projectsData:', COMPONENTS.projects.data)
    
    COMPONENTS.actu.data = await this.dataProcessor.loadActuData()
    console.log('actuData:', COMPONENTS.actu.data)

    COMPONENTS.apropos.data.statement = await this.dataProcessor.loadStatement()
    console.log('statementData:', COMPONENTS.apropos.data.statement)

    COMPONENTS.captcha.data.codes = await this.dataProcessor.loadCaptchaCodes()
    console.log('captchaCodes:', COMPONENTS.captcha.data.codes)

    // 3. Setup cursor
    CURSOR.cursor = new ImgCursor(CSS_RAW_VAR.followMouse)
    
    // 4. Setup UI components
    await this.setupComponents()
    
    // 5. Setup 3D world
    this.setup3dWorld(chatbotData)
  }

  /**
   * Setup UI components (cursor, notifbar, captcha, alertbox)
   */
  private async setupComponents(): Promise<void> {
    
    // A propos
    const aPropos = new APropos(COMPONENTS.apropos)
    aPropos.setup()
    if (!COMPONENTS.apropos) console.warn("[APropos] not setup globally")

    // Notifbar
    const notifbar = new Notifbar(COMPONENTS.notifbar)
    notifbar.setup()
    if (!COMPONENTS.notifbar) console.warn("[Notfibar] not setup globally")

    // Captcha
    const captcha = new Captcha(COMPONENTS.captcha)
    captcha.setup()
    if (!COMPONENTS.captcha) console.warn("[Captcha] not setup globally")
    
    // Alertbox
    const alertbox = new Alertbox(COMPONENTS.alertbox)
    alertbox.setup()
    if (!COMPONENTS.alertbox) console.warn("[Alerbox] not setup globally")

    // // chatbox
    // const chatbox = new Chatbox(COMPONENTS.chatbox)
    // chatbox.setup()
    // if (!COMPONENTS.chatbox) console.warn("[Chatbox] not setup globally")

    // Radio
    // const radio = new Radio(COMPONENTS.radio)
    // await radio.setup()
    // if (!COMPONENTS.radio) console.warn("[Radio] not setup globally")

    
    // Projets
    for (const [i, data] of COMPONENTS.projects.data.entries()) {
      const project = new Project(data, i)
      project.setup()
      COMPONENTS.projects.objects.push(project)
    }
    COMPONENTS.projects.objects.forEach(p => p.createLinks())
  
      // Actus
    const actu = new Actu(COMPONENTS.actu)
    await actu.setup()
    if (!COMPONENTS.actu) console.warn("[Actu] not setup globally")
  }

  /**
   * Setup 3d scene + thib
   */
  private async setup3dWorld(chatbotData: ProjectData | undefined): Promise<void> {
    const scene = new HomeScene()
    
    if (chatbotData) {
      const thib = new ThibTheCatElement(COMPONENTS.projects.data.length)
      thib.setup()
      const element = thib.getElement()
      if (!element) {
        console.warn('[HomeScene] Thib element not created')
        return
      }
      COMPONENTS.thib = element
    }

    await scene.setup()
  }

}

/* __________________________________________________________________________
|                                M A I N                                     |
|__________________________________________________________________________ */

// Initialize application
const app = new AppManager()
app.initialize()